"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ui = require("../../components/ui");

var DefaultAuthComponent = function DefaultAuthComponent(_ref) {
  var code = _ref.code,
      authContext = _ref.authContext;
  var initializing = authContext.initializing;

  if (initializing) {
    return /*#__PURE__*/_react.default.createElement("span", null, "Getting credentials");
  }

  switch (code) {
    case '401':
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, "\xA1Authentication is required!"), /*#__PURE__*/_react.default.createElement(_ui.Button, {
        onClick: authContext.login
      }, "Login"));

    case '403':
      return /*#__PURE__*/_react.default.createElement("span", null, "\xA1Forbidden path!");

    default:
      return /*#__PURE__*/_react.default.createElement("span", null, "\xA1Authentication error!");
  }
};

DefaultAuthComponent.displayName = 'DefaultAuthComponent';
DefaultAuthComponent.propTypes = {
  code: _propTypes.default.oneOf(['401', '403']),
  authContext: _propTypes.default.shape({
    login: _propTypes.default.func,
    initializing: _propTypes.default.bool
  })
};
var _default = DefaultAuthComponent;
exports.default = _default;